import React from "react";
import { ReadingEmailContext } from "../context/ReadingEmailContext";

export function useReadingEmail() {
  const context = React.useContext(ReadingEmailContext);

  if (context === undefined) {
    throw new Error("useReadingEmail must be used within a ReadingEmailProvider");
  }

  return context;
}
